import Caroussel from "../components/Caroussel";
import { useState, useEffect } from "react";
// import Press from "../components/Press";

function ProjectDetail({ project, setActiveProject }) {
    const [width, setWidth] = useState(window.innerWidth);
    useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    const fullText = (project.text ?? []).join(" ");
    const firstTwoWords = fullText.split(" ").slice(0, 2);
    const restOfText = fullText.split(" ").slice(2).join(" ");
    const widthVimeo = width < 544 ? "360" : "640";
    const heightVimeo = width < 544 ? "480" : "360";
    return (
        <div className="main-section project-detail">
            <div className="project-detail-title-container">
                <button
                    onClick={() => setActiveProject(null)}
                    className="btn back-btn"
                >
                    <ion-icon name="arrow-back-circle-outline"></ion-icon>
                </button>
                <h1 className="project-detail-title">{project.title}</h1>
            </div>
            {project.images && <Caroussel images={project.images} />}
            <div className="project-text-container">
                <p>
                    <strong className="emphasized-text">
                        {firstTwoWords.join(" ")}
                    </strong>
                    {` ${restOfText}`}
                </p>
            </div>
            {project.videoUrl && (
                <div className="iframe-container">
                    <iframe
                        title="vimeo-player"
                        src={project.videoUrl}
                        width={widthVimeo}
                        height={heightVimeo}
                        frameBorder="0"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                    ></iframe>
                </div>
            )}
            {/* {project.press && <Press press={project.press} />} */}
        </div>
    );
}

export default ProjectDetail;
